import { tokens } from '@airtel/air-design-system';
import { StyleSheet } from 'react-native';
export var getOfferPopupWidgetStyles = isSmallScreen => {
  return StyleSheet.create({
    container: {
      width: isSmallScreen ? 222 : 462,
      alignItems: 'center'
    },
    textAlignCenter: {
      textAlign: 'center'
    },
    subTitle: {
      marginTop: tokens.spacing.SPACING_16
    },
    imageUrl: {
      marginTop: tokens.spacing.SPACING_8
    },
    offerHeading: {
      marginTop: tokens.spacing.SPACING_8
    },
    offerSubHeading: {
      marginTop: tokens.spacing.SPACING_4
    },
    ctaText: {
      marginTop: tokens.spacing.SPACING_20
    },
    offerTitle: {
      marginBottom: tokens.spacing.SPACING_12,
      textAlign: 'center'
    }
  });
};